import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
var render = function render() {
  var _vm$dbPurchaseOrder, _vm$dbPurchaseOrder2;
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c(VDataTable, {
    staticClass: "elevation-1",
    attrs: {
      headers: _vm.headers,
      items: _vm.isLoadingOptions ? [] : _vm.selectedItems,
      loading: _vm.isLoadingOptions,
      "hide-default-footer": "",
      "disable-pagination": ""
    },
    scopedSlots: _vm._u([{
      key: "top",
      fn: function fn() {
        return [_c(VToolbar, {
          attrs: {
            flat: ""
          }
        }, [_c(VToolbarTitle, [_vm._v("Items details")]), _c(VDivider, {
          staticClass: "mx-4",
          attrs: {
            inset: "",
            vertical: ""
          }
        }), _c(VSpacer), _vm.isReadOnly || !_vm.supplierId ? _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var on = _ref.on,
                attrs = _ref.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "not-allowed"
              }, "div", attrs, false), on), [_c(VBtn, {
                staticClass: "mb-2 dfwa-btn --small secondary",
                attrs: {
                  disabled: ""
                }
              }, [_c(VIcon, {
                staticClass: "fa fa-plus mr-1",
                attrs: {
                  size: "0.65rem"
                }
              }), _vm._v(" Create new product ")], 1)], 1)];
            }
          }], null, false, 2186807719)
        }, [_c("span", [_vm._v("No supplier selected.")])]) : _c(VBtn, {
          staticClass: "mb-2 dfwa-btn --small secondary",
          on: {
            click: function click($event) {
              return _vm.openNewWineDialog();
            }
          }
        }, [_c(VIcon, {
          staticClass: "fa fa-plus mr-1",
          attrs: {
            size: "0.65rem"
          }
        }), _vm._v(" Create new Wine ")], 1), _c(VDivider, {
          staticClass: "mx-2",
          attrs: {
            inset: "",
            vertical: ""
          }
        }), !_vm.isLoadingOptions && !_vm.options.length && !!_vm.supplierId ? _c(VTooltip, {
          attrs: {
            top: ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref2) {
              var on = _ref2.on,
                attrs = _ref2.attrs;
              return [_c("div", _vm._g(_vm._b({
                staticClass: "not-allowed"
              }, "div", attrs, false), on), [_c(VBtn, {
                staticClass: "mb-2 dfwa-btn --small secondary",
                attrs: {
                  disabled: ""
                }
              }, [_c(VIcon, {
                staticClass: "fa fa-plus mr-1",
                attrs: {
                  size: "0.65rem"
                }
              }), _vm._v(" Add Item ")], 1)], 1)];
            }
          }], null, false, 3115677184)
        }, [_c("span", [_vm._v("There is no product available from this supplier.")])]) : _c(VDialog, {
          attrs: {
            persistent: "",
            "max-width": "950"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref3) {
              var on = _ref3.on,
                attrs = _ref3.attrs;
              return [_c(VBtn, _vm._g(_vm._b({
                staticClass: "mb-2 dfwa-btn --small secondary",
                attrs: {
                  loading: _vm.isLoadingOptions,
                  disabled: _vm.disabled || !_vm.isLoadingOptions && !_vm.options.length
                },
                on: {
                  click: function click($event) {
                    return _vm.assignWarehouseDefaultCountries();
                  }
                }
              }, "v-btn", attrs, false), on), [_c(VIcon, {
                staticClass: "fa fa-plus mr-1",
                attrs: {
                  size: "0.65rem"
                }
              }), _vm._v(" Add Item ")], 1)];
            }
          }]),
          model: {
            value: _vm.dialog,
            callback: function callback($$v) {
              _vm.dialog = $$v;
            },
            expression: "dialog"
          }
        }, [_c(VCard, [_c("div", {
          staticClass: "dialog-closer"
        }, [_c(VIcon, {
          staticClass: "far fa-times-circle",
          on: {
            click: _vm.close
          }
        })], 1), _c(VForm, {
          staticClass: "form text-left",
          model: {
            value: _vm.form.valid,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "valid", $$v);
            },
            expression: "form.valid"
          }
        }, [_c(VCardTitle, [_c("span", {
          staticClass: "text-h5"
        }, [_vm._v(_vm._s(_vm.formTitle))])]), _c(VCardText, [_c(VContainer, {
          staticClass: "mt-0 pt-0"
        }, [_c(VRow, [_c(VCol, {
          attrs: {
            cols: "12",
            "align-self": "center"
          }
        }, [_c(VRow, [_c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            clearable: "",
            disabled: _vm.editedItem.isBeingEdited || _vm.options.length === 0,
            value: _vm.editedItem.wineId,
            items: _vm.options,
            "item-text": "_searchable_name",
            "item-value": "wineId",
            placeholder: "Select an item name",
            label: "Name",
            "hide-details": "auto",
            required: "",
            rules: [_vm.rules.mustSelectValue],
            filter: _vm.filterVAutocomplete
          },
          on: {
            change: _vm.changeItem
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12",
            sm: "6",
            md: "6"
          }
        }, [_c(VTextField, {
          staticClass: "required",
          attrs: {
            required: "",
            readonly: "",
            label: "PoItemSKU (auto:Product+Suffix)",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          },
          model: {
            value: _vm.editedItem.sku,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "sku", $$v);
            },
            expression: "editedItem.sku"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12",
            sm: "4",
            md: "4"
          }
        }, [_c(VTextField, {
          attrs: {
            value: _vm.editedItem.accountancyCode,
            readonly: "",
            label: "Product SKU",
            rules: [_vm.rules.mustNotBeEmpty],
            "hide-details": "auto"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12",
            sm: "2",
            md: "2"
          }
        }, [_c(VTextField, {
          attrs: {
            label: "Suffix SKU",
            "hide-details": "auto"
          },
          on: {
            input: _vm.updateSkuSuffix
          },
          model: {
            value: _vm.editedItem.skuSuffix,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "skuSuffix", $$v);
            },
            expression: "editedItem.skuSuffix"
          }
        })], 1), _vm.isLoadingStocks ? _c(VSkeletonLoader, {
          attrs: {
            width: "100%",
            type: "list-item-two-line"
          }
        }) : [_c(VCol, {
          attrs: {
            cols: "12",
            sm: "6",
            md: "4"
          }
        }, [_c(VTextField, {
          staticClass: "required",
          attrs: {
            type: "number",
            label: "Quantity (bottles)",
            min: "0",
            required: "",
            rules: [_vm.rules.mustBeGreaterThan0],
            "hide-details": "auto"
          },
          on: {
            change: _vm.changeQuantity
          },
          model: {
            value: _vm.editedItem.quantity,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "quantity", $$v);
            },
            expression: "editedItem.quantity"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12",
            sm: "6",
            md: "4"
          }
        }, [_c(VTextField, {
          attrs: {
            type: "number",
            label: "COGS",
            "hide-details": "auto",
            rules: [_vm.rules.mustNotBeEmpty],
            suffix: "€ ex.vat"
          },
          on: {
            input: _vm.changeRate
          },
          model: {
            value: _vm.editedItem.rate,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "rate", _vm._n($$v));
            },
            expression: "editedItem.rate"
          }
        }), _vm.editedItem.wineId && _vm.editedItem.rate === 0 ? _c("div", {
          staticClass: "text-red"
        }, [_vm._v(" The product's price has not yet been set. ")]) : _vm._e(), !!_vm.editedItem.wineId && Math.abs(_vm.editedItemDbCogs - _vm.editedItem.rate) > 0.75 ? _c("div", {
          staticClass: "text-red mt-1"
        }, [_c("strong", [_vm._v("Please notify the order team")]), _vm._v(" . "), _c("br"), _vm._v(" The product COGS on the "), _c("router-link", {
          attrs: {
            to: _vm.toProductDetails(_vm.editedItem),
            target: "_blank"
          }
        }, [_vm._v(" product details ")]), _vm._v(" is set to " + _vm._s(_vm.editedItemDbCogs) + ", Maybe an update should be done. ")], 1) : _vm._e()], 1), _c(VCol, {
          attrs: {
            cols: "12",
            sm: "6",
            md: "4"
          }
        }, [_c(VTextField, {
          attrs: {
            disabled: "",
            type: "number",
            label: "Amount",
            "hide-details": "auto",
            suffix: "€ ex.vat"
          },
          model: {
            value: _vm.editedItem.amount,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "amount", _vm._n($$v));
            },
            expression: "editedItem.amount"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_c(VSelect, {
          staticClass: "required",
          attrs: {
            chips: "",
            loading: _vm.isLoadingStocks,
            disabled: _vm.editedItem.hasStocks,
            items: _vm.countries,
            label: "Intended countries",
            "item-text": "printable_name",
            "item-value": "id_country",
            placeholder: "France",
            "hide-details": "auto",
            required: "",
            rules: [_vm.rules.mustSelectValue],
            multiple: ""
          },
          scopedSlots: _vm._u([{
            key: "selection",
            fn: function fn(_ref4) {
              var item = _ref4.item,
                index = _ref4.index;
              return [_vm.allCountriesSelected ? [index === 0 ? _c("span", [_vm._v("All")]) : _vm._e()] : _c(VChip, [_c("span", [_vm._v(_vm._s(item.printable_name))])])];
            }
          }, {
            key: "prepend-item",
            fn: function fn() {
              return [_c(VListItem, {
                attrs: {
                  ripple: ""
                },
                on: {
                  click: _vm.toggle
                }
              }, [_c(VListItemAction, [_c(VIcon, [_vm._v(" " + _vm._s(_vm.icon) + " ")])], 1), _c(VListItemContent, [_c(VListItemTitle, [_vm._v("Select All")])], 1)], 1)];
            },
            proxy: true
          }]),
          model: {
            value: _vm.editedItem.intendedCountryIds,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "intendedCountryIds", $$v);
            },
            expression: "editedItem.intendedCountryIds"
          }
        }), _vm.editedItem.hasStocks ? _c("div", {
          staticClass: "mt-1 text-italic"
        }, [_vm._v(" You can't change the countries because a stock already exists for this product at "), _c("strong", [_vm._v(_vm._s(_vm.warehouse.name) + ".")])]) : _vm._e()], 1), _c(VCol, {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: false,
            expression: "false"
          }],
          attrs: {
            cols: "12"
          }
        }, [_c(VCheckbox, {
          attrs: {
            label: "Transfer from an existing warehouse stock",
            "hide-details": "auto",
            disabled: _vm.isReadOnly || _vm.isSaving || !_vm.isWarehouseStocksAvailableForItem
          },
          on: {
            change: _vm.changeFromWarehouseStock
          },
          model: {
            value: _vm.isFromWarehouseStock,
            callback: function callback($$v) {
              _vm.isFromWarehouseStock = $$v;
            },
            expression: "isFromWarehouseStock"
          }
        }), !_vm.isWarehouseStocksAvailableForItem && _vm.editedItem.wineId > 0 ? _c("div", {
          staticClass: "mt-1 text-italic"
        }, [_vm._v(" There is NO QUANTITY SET, or the PO is creating direct producer stocks, or there is no warehouse stock compatible with this product. ")]) : _vm._e(), _vm.isFromWarehouseStock ? _c("div", {
          staticClass: "mt-2"
        }, [_c(VAutocomplete, {
          staticClass: "required",
          attrs: {
            clearable: "",
            disabled: _vm.warehouseStocksAvailableForItem.length === 0,
            value: _vm.editedItem.wineId,
            items: _vm.warehouseStocksAvailableForItem,
            "item-text": "_searchable_name",
            "item-value": "id_stock",
            placeholder: "Select a warehouse stock",
            label: "Warehouse stock",
            "hide-details": "auto",
            required: "",
            rules: [_vm.rules.mustSelectValue],
            filter: _vm.filterVAutocomplete
          },
          on: {
            change: _vm.changeFromWarehouseStockId
          },
          model: {
            value: _vm.editedItem.fromWarehouseStockId,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "fromWarehouseStockId", $$v);
            },
            expression: "editedItem.fromWarehouseStockId"
          }
        })], 1) : _vm._e()], 1), _c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_c(VCheckbox, {
          attrs: {
            label: "Filling order(s)",
            "hide-details": "auto",
            disabled: _vm.isReadOnly || _vm.isSaving || !_vm.isOrdersFillableForItem
          },
          on: {
            change: _vm.changeFillingOrders
          },
          model: {
            value: _vm.isFillingOrders,
            callback: function callback($$v) {
              _vm.isFillingOrders = $$v;
            },
            expression: "isFillingOrders"
          }
        }), !_vm.isOrdersFillableForItem && _vm.editedItem.wineId > 0 ? _c("div", {
          staticClass: "mt-1 text-italic"
        }, [_vm._v(" There is NO QUANTITY SET, or the PO is creating direct producer stocks, or there is no order compatible fillable with this product. ")]) : _vm._e(), _vm.availableFillingOrdersCanBeDbUnsynced ? _c("div", {
          staticClass: "text-orange"
        }, [_vm._v(" You may Save PO, and reload this interface to refresh available filling orders ")]) : _vm._e(), _vm.isFillingOrders ? _c("div", {
          staticClass: "mt-2"
        }, [_c("PurchaseOrderItemsQuantitiesOrderTable", {
          staticClass: "full",
          attrs: {
            poId: _vm.isEditingPo ? +_vm.dbPurchaseOrder.id : 0,
            poItems: _vm.items,
            parentItem: _vm.editedItem,
            disabled: _vm.isReadOnly || _vm.isSaving,
            ordersFillable: _vm.ordersFillableForItem
          },
          on: {
            save: _vm.saveQuantitiesForOrders
          }
        })], 1) : _vm._e()], 1), _c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_c(VCheckbox, {
          attrs: {
            label: _vm.gettingUserList.isPending || _vm.gettingConsultantList.isPending ? "Loading required data ..." : "Override default warehouse stock reservation / make specific reservations",
            "hide-details": "auto",
            disabled: _vm.gettingUserList.isPending || !_vm.editedItem.quantity > 0 || _vm.isReadOnly || _vm.isSaving
          },
          on: {
            change: _vm.changeOverrideStockReservationType
          },
          model: {
            value: _vm.isOverrideStockReservationType,
            callback: function callback($$v) {
              _vm.isOverrideStockReservationType = $$v;
            },
            expression: "isOverrideStockReservationType"
          }
        }), !!_vm.defaultReservationLabel ? _c("div", {
          staticClass: "mt-1 text-italic"
        }, [_vm._v(" " + _vm._s(_vm.defaultReservationLabel) + " ")]) : _vm._e(), !_vm.editedItem.quantity > 0 ? _c("div", {
          staticClass: "mt-1 text-italic"
        }, [_vm._v(" There is NO QUANTITY SET. ")]) : _vm._e(), _vm.isOverrideStockReservationType ? _c("div", {
          staticClass: "mt-1"
        }, [_c("PurchaseOrderItemsReservationTable", {
          staticClass: "full",
          attrs: {
            parentItem: _vm.editedItem,
            disabled: _vm.isReadOnly || _vm.isSaving || _vm.gettingUserList.isPending,
            userList: _vm.gettingUserList.results,
            consultantList: _vm.gettingConsultantList.results
          },
          on: {
            save: _vm.saveReservations
          }
        })], 1) : _vm._e()], 1), _c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_c(VCheckbox, {
          attrs: {
            label: "Change product COGS at reception ? (not allowed)",
            "hide-details": "auto",
            disabled: ""
          },
          on: {
            change: _vm.changeNewCogs
          },
          model: {
            value: _vm.isThereNewCogs,
            callback: function callback($$v) {
              _vm.isThereNewCogs = $$v;
            },
            expression: "isThereNewCogs"
          }
        })], 1), _c(VCol, {
          attrs: {
            cols: "12"
          }
        }, [_vm.isThereNewCogs ? _c(VTextField, {
          attrs: {
            type: "number",
            label: "New COGS",
            min: "0.01",
            "hide-details": "auto",
            suffix: "€",
            rules: [_vm.rules.mustBeGreaterThan0]
          },
          model: {
            value: _vm.editedItem.newCogs,
            callback: function callback($$v) {
              _vm.$set(_vm.editedItem, "newCogs", _vm._n($$v));
            },
            expression: "editedItem.newCogs"
          }
        }) : _vm._e()], 1)]], 2)], 1)], 1)], 1)], 1), _c(VCardActions, [_c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.close
          }
        }, [_vm._v("Cancel")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: "",
            disabled: !_vm.form.valid || _vm.isLoadingStocks
          },
          on: {
            click: _vm.save
          }
        }, [_vm._v(" Apply changes ")])], 1)], 1)], 1)], 1), _c(VDialog, {
          attrs: {
            "max-width": "500px"
          },
          model: {
            value: _vm.dialogDelete,
            callback: function callback($$v) {
              _vm.dialogDelete = $$v;
            },
            expression: "dialogDelete"
          }
        }, [_c(VCard, [_c(VToolbar, {
          attrs: {
            color: "primary",
            dense: "",
            flat: ""
          }
        }, [_c(VToolbarTitle, {
          staticClass: "dialog-title"
        }, [_vm._v("Confirm")])], 1), _c(VCardText, {
          staticClass: "pa-4 dialog-message"
        }, [_vm._v(" Are you sure you want to delete this item ? ")]), _c(VCardActions, [_c(VBtn, {
          staticClass: "dfwa-btn --small secondary",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.closeDelete
          }
        }, [_vm._v("No")]), _c(VBtn, {
          staticClass: "dfwa-btn --small",
          attrs: {
            rounded: ""
          },
          on: {
            click: _vm.deleteItemConfirm
          }
        }, [_vm._v("Yes")])], 1)], 1)], 1), _vm.newWineModalShown ? _c("NewWineDialog", {
          attrs: {
            shown: _vm.newWineModalShown,
            loggedUserData: _vm.loggedUserData,
            producerId: _vm.producerId
          },
          on: {
            close: _vm.closeNewWineDialog,
            saved: _vm.newWineSaved
          }
        }) : _vm._e()], 1)];
      },
      proxy: true
    }, {
      key: "item.name",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_vm._v(" " + _vm._s(item.name) + " "), _c("router-link", {
          staticClass: "router-link ml-2",
          attrs: {
            to: _vm.toProductDetails(item),
            target: "_blank",
            title: "Open product details"
          }
        }, [_c("i", {
          staticClass: "fas fa-external-link-alt"
        })])];
      }
    }, {
      key: "item.fill",
      fn: function fn(_ref6) {
        var _item$quantitiesForOr, _vm$ordersFillableRes, _vm$ordersFillableRes2;
        var item = _ref6.item;
        return [_vm.isCheckingOrdersFillable ? _c(VProgressCircular, {
          attrs: {
            indeterminate: "",
            size: "20",
            width: "1"
          }
        }) : _vm.isCancelledPo || _vm.ordersFillableResponse === null ? _c("span", [_vm._v("-")]) : _vm.isEditingPo && item.id > 0 ? [+item.quantity === ((_item$quantitiesForOr = item.quantitiesForOrders) === null || _item$quantitiesForOr === void 0 ? void 0 : _item$quantitiesForOr.reduce(function (acc, x) {
          return acc + x.quantity;
        }, 0)) ? [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref7) {
              var on = _ref7.on,
                attrs = _ref7.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, {
                staticClass: "text-success"
              }, [_vm._v("fa-check")])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_vm._v("All bottles are linked to an order")])], 1)] : !((_vm$ordersFillableRes = _vm.ordersFillableResponse.winesFillable) !== null && _vm$ordersFillableRes !== void 0 && _vm$ordersFillableRes.find(function (x) {
          return x.wineId === item.wineId;
        })) ? [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref8) {
              var on = _ref8.on,
                attrs = _ref8.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, {
                staticClass: "text-success"
              }, [_vm._v("fa-check")])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_vm._v("No order to fill")])], 1)] : !((_vm$ordersFillableRes2 = _vm.ordersFillableResponse.winesFillable) !== null && _vm$ordersFillableRes2 !== void 0 && (_vm$ordersFillableRes2 = _vm$ordersFillableRes2.find(function (x) {
          return x.wineId === item.wineId;
        })) !== null && _vm$ordersFillableRes2 !== void 0 && (_vm$ordersFillableRes2 = _vm$ordersFillableRes2.ordersFillable) !== null && _vm$ordersFillableRes2 !== void 0 && _vm$ordersFillableRes2.some(function (orderFillable) {
          var _item$quantitiesForOr2;
          return !((_item$quantitiesForOr2 = item.quantitiesForOrders) !== null && _item$quantitiesForOr2 !== void 0 && _item$quantitiesForOr2.map(function (orderFilled) {
            return orderFilled.orderId;
          }).includes(orderFillable.id));
        })) ? [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref9) {
              var on = _ref9.on,
                attrs = _ref9.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, {
                staticClass: "text-warning"
              }, [_vm._v("fa-check")])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_vm._v("All orders seem filled, maybe only partially")])], 1)] : [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref10) {
              var on = _ref10.on,
                attrs = _ref10.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, {
                staticClass: "text-error"
              }, [_vm._v("mdi-alert")])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_vm._v("It seems that an order can be filled")])], 1)]] : [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref11) {
              var on = _ref11.on,
                attrs = _ref11.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, [_vm._v("fa-question")])], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_c("div", [_vm._v("New item, or quantity changed.")]), _c("div", [_vm._v("You must save the purchase order to get the filling status")])])], 1)]];
      }
    }, {
      key: "item.quantity",
      fn: function fn(_ref12) {
        var _item$fromWarehouseSt;
        var item = _ref12.item;
        return [_c("div", [_vm._v(_vm._s(item.quantity) + " btls")]), (_item$fromWarehouseSt = item.fromWarehouseStock) !== null && _item$fromWarehouseSt !== void 0 && _item$fromWarehouseSt.warehouse ? _c("div", {
          class: ["text-smaller-2", !_vm.isCancelledPo && !_vm.isReceivedPo && item.fromWarehouseStock.quantity < item.quantity ? "text-orange" : ""],
          attrs: {
            title: !_vm.isCancelledPo && !_vm.isReceivedPo && item.fromWarehouseStock.quantity < item.quantity ? "Only ".concat(item.fromWarehouseStock.quantity, " btl(s) available on this stock") : ""
          }
        }, [!_vm.isCancelledPo && !_vm.isReceivedPo && item.fromWarehouseStock.quantity < item.quantity ? _c(VIcon, {
          staticClass: "fas fa-exclamation-triangle text-orange",
          attrs: {
            size: "0.5rem"
          }
        }) : _vm._e(), _vm._v(" From " + _vm._s(item.fromWarehouseStock.warehouse.name) + " ")], 1) : _vm._e(), item.quantitiesForOrders.length > 0 ? _c("div", {
          staticClass: "text-smaller text-italic"
        }, _vm._l(item.quantitiesForOrders, function (quantityForOrder) {
          return _c("div", {
            key: quantityForOrder.orderId,
            staticClass: "text-nowrap"
          }, [_vm._v(" " + _vm._s(quantityForOrder.quantity) + " for "), _c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: {
                name: "adminOrderSummary",
                params: {
                  id: quantityForOrder.orderId
                }
              },
              target: "_blank"
            }
          }, [_vm._v(" " + _vm._s(quantityForOrder.orderReference.shorterReference()) + " ")])], 1);
        }), 0) : _vm._e(), false && item.reservations.filter(function (x) {
          return x.type == _vm.stockReservationTypes.SPECIFIC_CUSTOMER.id;
        }).length > 0 ? _c("div", {
          staticClass: "text-smaller text-italic text-nowrap"
        }, [_vm._v(" " + _vm._s(item.reservations.filter(function (x) {
          return x.type == _vm.stockReservationTypes.SPECIFIC_CUSTOMER.id;
        }).reduce(function (acc, x) {
          return acc + +x.quantity;
        }, 0)) + " for customers ")]) : _vm._e()];
      }
    }, {
      key: "item.rate",
      fn: function fn(_ref13) {
        var item = _ref13.item;
        return [_c("div", {
          staticClass: "td-without-link text-center text-nowrap",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("div", [_vm._v(_vm._s(_vm.formatPrice(item.rate)) + " €")]), item.wineCogsEuroDefined ? _c("div", {
          staticClass: "text-smaller"
        }, [_vm._v(" COGS: " + _vm._s(_vm.formatPrice(item.wineCogsEuroDefined)) + " € ")]) : _vm._e()])];
      }
    }, {
      key: "item.amount",
      fn: function fn(_ref14) {
        var item = _ref14.item;
        return [_c("div", {
          staticClass: "text-nowrap text-center"
        }, [_c("div", [_vm._v(_vm._s(_vm.formatPrice(item.amount)) + " €")]), _vm.canManageSupplierPrices ? _c(VBtn, {
          class: ["dfwa-btn", "--small-3", "px-1", "mb-1", _vm.getClassSupplierPriceButton(item)],
          attrs: {
            loading: _vm.gettingSupplierPrices.isPending,
            rounded: true,
            title: _vm.getInfoSupplierPriceButton(item)
          },
          on: {
            click: function click($event) {
              return _vm.openSupplierPrices(item);
            }
          }
        }, [_vm._v(" sup.prices ")]) : _vm._e()], 1)];
      }
    }, {
      key: "item.stock",
      fn: function fn(_ref15) {
        var item = _ref15.item;
        return [_c("div", {
          key: item.stockBadge,
          staticClass: "td-without-link text-center",
          on: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [!item.stockBadge ? _c(VIcon, {
          staticClass: "fas fa-sync",
          on: {
            click: function click($event) {
              return _vm.initWineStock(item);
            }
          }
        }) : !item.isStockFetched ? _c(VProgressCircular, {
          attrs: {
            indeterminate: "",
            size: "20",
            width: "1"
          }
        }) : [_c(VMenu, {
          attrs: {
            top: "",
            "offset-y": "",
            "open-on-hover": "",
            "open-delay": 500,
            disabled: !item.stockTitle
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref16) {
              var on = _ref16.on,
                attrs = _ref16.attrs;
              return [_c("div", _vm._g(_vm._b({}, "div", attrs, false), on), [_c(VIcon, {
                staticClass: "fas fa-dungeon",
                class: item.stockBadge,
                staticStyle: {
                  opacity: "0.7"
                },
                attrs: {
                  size: "20"
                },
                on: {
                  click: function click($event) {
                    return _vm.openPurchaseOrderStocksDialog(item);
                  }
                }
              })], 1)];
            }
          }], null, true)
        }, [_c(VCard, {
          staticClass: "hover-tooltip"
        }, [_vm._v(_vm._s(item.stockTitle))])], 1)]], 2)];
      }
    }, !_vm.disabled ? {
      key: "item.actions",
      fn: function fn(_ref17) {
        var item = _ref17.item;
        return [_c(VIcon, {
          staticClass: "mr-2",
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.editItem(item);
            }
          }
        }, [_vm._v("mdi-pencil")]), _c(VIcon, {
          attrs: {
            small: ""
          },
          on: {
            click: function click($event) {
              return _vm.deleteItem(item);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    } : null], null, true)
  }), _c("div", {
    staticClass: "mt-3 flex align-baseline justify-end"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small secondary",
    attrs: {
      rounded: "",
      disabled: !_vm.isEditingPo || ((_vm$dbPurchaseOrder = _vm.dbPurchaseOrder) === null || _vm$dbPurchaseOrder === void 0 ? void 0 : _vm$dbPurchaseOrder.isPreArrivalStockCreated),
      loading: _vm.creatingAllPreArrivalStocks.isPending
    },
    on: {
      click: _vm.confirmCreateAllPreArrivalStocks
    }
  }, [_c(VIcon, {
    staticClass: "fas fa-dungeon mr-2",
    attrs: {
      size: "0.85rem"
    }
  }), (_vm$dbPurchaseOrder2 = _vm.dbPurchaseOrder) !== null && _vm$dbPurchaseOrder2 !== void 0 && _vm$dbPurchaseOrder2.isPreArrivalStockCreated ? [_vm._v(" All pre-arrival stocks already created ")] : [_vm._v("Create all pre-arrival stocks")]], 2)], 1), _vm.isWineSupplierPriceModalShown ? _c("WineSupplierPriceModal", {
    ref: "wineSupplierPriceModal",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      wineId: _vm.currentWineId,
      supplierId: _vm.supplierId,
      isAllowToApplyPrice: !_vm.isReadOnly
    },
    on: {
      applied: function applied(itemSupplier, ack) {
        _vm.applyNewSupplierPrice(itemSupplier, ack);
      },
      saved: _vm.fetchAllWinesSupplierPrices,
      added: _vm.fetchAllWinesSupplierPrices,
      closed: _vm.closeSupplierPrices
    }
  }) : _vm._e(), _vm.isPurchaseOrderStocksModalShown ? _c("PurchaseOrderStocksModal", {
    ref: "purchaseOrderStocksModal",
    attrs: {
      loggedUserData: _vm.loggedUserData,
      item: _vm.editedItem,
      purchaseOrder: _vm.dbPurchaseOrder
    },
    on: {
      reloaded: _vm.reloadPurchaseOrderStocks,
      closed: _vm.closePurchaseOrderStocks
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };